import React, { useState, useEffect } from 'react';
import { Link, useParams } from "react-router-dom";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import ResetPassword from '../components/password/ResetPassword';
import UserService from '../services/UserService';

const minWidth = 300;

export default function ResetPasswordPage() {
    const { token } = useParams(); // reset token from url
    const [loading, setLoading] = useState(true);
    const [tokenError, setTokenError] = useState(false);

    // lookup the reset token
    useEffect(() => {
        try {
            UserService.checkPasswordResetToken(token)
            .catch((error) => setTokenError(error.response.data.message))
            .then((data) => {
                setLoading(false);
            });
        } catch(err) {
            setTokenError(true)
            setLoading(false);
        }
    }, [token]);

    if(loading) return null;

    return (
        <Grid container direction='column' sx={{ minWidth }}>
            <div>
            <AppBar
                position='static'
                sx={{
                    '&.MuiPaper-elevation0': {
                        background: 'white'
                    },
                    flexGrow: 1,
                    padding: '1em',
                    transition: 'linear 0.5s',
                    position: 'sticky',
                    top: '-1px',
                    minWidth
                }}>
                    <Grid container justifyContent='space-around'>
                        <Grid item xs={3}>
                            <Grid container alignContent='center' justifyContent='center'>
                                {' '}
                                <Box pl={1}>
                                    <Typography variant='h4'>VYU1</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid item xs>
                            <Grid
                                container
                                alignItems='center'
                                alignContent='center'
                                justifyContent='flex-end'
                                spacing={2}>
                            <Grid item>
                                {/* <Button
                                    variant='outlined'
                                    size='small'
                                    color={'primary'}
                                    onClick={() => setShowLogin(true)}>
                                    Login
                                </Button> */}
                            </Grid>
                            <Grid item>
                                {/* <Button
                                    variant='contained'
                                    size='small'
                                    color={'primary'}
                                    onClick={() => setShowJoin(true)}>
                                    Join
                                </Button> */}
                            </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </AppBar>
                {/* This container holds everything below the title bar */}
                <Box
                    component='div'
                    sx={{
                        minWidth,
                        // width: '100vw',
                        height: '100%',
                        background: 'white',
                        position: 'relative'
                    }}>
                    <Container maxwidth>
                        <Box py={2}>
                            <Grid container justifyContent='center' alignItems='center'>
                                <Grid item>
                                    <Grid container justifyContent='center' direction='column'>
                                        <Typography variant='h3' align='center'>
                                            VYU1 - Reset Password
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={6} style={{ marginTop: 16 }}>
                                    <Grid container>
                                        {!!token || tokenError ?
                                            <Typography variant="p" direction="column">
                                                The password reset token is invalid or timed out. Please use the <Link to="/forgot-password">forgot password</Link> form and try again.
                                            </Typography> :
                                            <ResetPassword/>
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </Container>
                </Box>
            </div>
        </Grid>
    );
}
